import { AxiosResponse } from 'axios';
import { appContextGet, appContextPost } from './httpCommon/appAxios.service';
import { InsuredCustomer } from '../types/interfaces/reports.interface';
import { INSURED_CUSTOMERS_REPORTS_ENDPOINTS } from '../constants/apiEndpoints';

export const getInsuredCustomersOdata = (query?: {}): Promise<AxiosResponse<InsuredCustomer[], any>> => {
  return appContextGet(INSURED_CUSTOMERS_REPORTS_ENDPOINTS.INSURED_CUSTOMERS_ODATA, query);
};

export const getInsuredCustomerById = (shippingTransactionId: number): Promise<AxiosResponse<InsuredCustomer, any>> => {
  return appContextGet(INSURED_CUSTOMERS_REPORTS_ENDPOINTS.INSURED_CUSTOMERS_ + shippingTransactionId);
};

export const downloadInsuredCustomersReport = (payload?: {}, query?: {}): Promise<AxiosResponse<any, any>> => {
  return appContextPost(INSURED_CUSTOMERS_REPORTS_ENDPOINTS.INSURED_CUSTOMERS_REPORT_DOWNLOAD, payload, query, {
    responseType: 'blob',
  });
};
